import classNames from '@/lib/class-names';
import type { ComponentProps, ElementType, ReactElement } from 'react';

const AlertDefaultElement = 'div';

interface Alert {
  <E extends ElementType = typeof AlertDefaultElement>(props: AlertProps<E>): ReactElement<any, any>;
  displayName: string;
}

type AlertProps<E extends ElementType> = AlertOwnProps<E> & Omit<ComponentProps<E>, keyof AlertOwnProps>;

type AlertOwnProps<E extends ElementType = ElementType> = {
  as?: E;
  className?: string;
  severity?: 'none' | 'success' | 'info' | 'warning' | 'error';
};

const Alert: Alert = ({ className, severity = 'none', ...rest }) => (
  <div
    {...rest}
    className={classNames(
      'rounded-md border py-2 px-4',
      // severity === 'none' && '',
      severity === 'info' && 'border-info-focus bg-info/10 text-info-focus',
      severity === 'success' && 'border-success-focus bg-success/10 text-success-focus',
      severity === 'error' && 'border-error-focus bg-error/10 text-error-focus',
      severity === 'warning' && 'border-warning-focus bg-warning/10 text-warning-focus',
      className,
    )}
  />
);

Alert.displayName = 'Alert';

export default Alert;
